import { render, staticRenderFns } from "./teamData.vue?vue&type=template&id=96247798&scoped=true"
import script from "./teamData.vue?vue&type=script&lang=js"
export * from "./teamData.vue?vue&type=script&lang=js"
import style0 from "./teamData.vue?vue&type=style&index=0&id=96247798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96247798",
  null
  
)

export default component.exports